import React, { useState } from "react";
import RCSPlainTextMsg from "./RCSPlainTextMsg";
import RCSTextWithCtaMsg from "./RCSTextWithCtaMsg";
import RCSDialNowMsg from "./RCSDialNowMsg";
import RCSReplySuggestionMsg from "./RCSReplySuggestionMsg";

const tabs = [
  { id: "PLAINTEXT", label: "Plain Text" },
  { id: "CTA", label: "Text With CTA" },
  { id: "Dialer", label: "Text with Dialer" },
  { id: "Suggestion", label: "Text with Suggestion" },
];

const RCSSPainText = () => {
  const [activeTab, setActiveTab] = useState("PLAINTEXT");

  const wrapperStyle = {
    borderBottom: "1px solid #e4e4e4",
    backgroundColor: "#f3f4f6",
    paddingLeft: "16px",
    paddingTop: "10px",
  };

  const tabStyle = {
    padding: "8px 20px",
    border: "none",
    outline: "none",
    borderTopLeftRadius: "6px",
    borderTopRightRadius: "6px",
    backgroundColor: "#ffffff",
    color: "#000",
    fontWeight: "bold",
    cursor: "pointer",
    fontSize: "14px",
    marginRight: "0px",
    position: "relative",
    top: "1px",
    zIndex: 1,
  };

  const activeTabStyle = {
    ...tabStyle,
    backgroundColor: "#00bcd4",
    color: "#fff",
    zIndex: 2,
  };

  return (
    <div>
      {/* Tabs wrapper with border */}
      <div style={wrapperStyle}>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          {tabs.map((tab) => (
            <button
              key={tab.id}
              style={activeTab === tab.id ? activeTabStyle : tabStyle}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div style={{ padding: "16px" }}>
        {activeTab === "PLAINTEXT" && <RCSPlainTextMsg />}
        {activeTab === "CTA" && <RCSTextWithCtaMsg />}
        {activeTab === "Dialer" && <RCSDialNowMsg />}
        {activeTab === "Suggestion" && <RCSReplySuggestionMsg />}
      </div>
    </div>
  );
};

export default RCSSPainText;
